// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getProductHierarchy} from '../../shared/repositories';

export const readProductHierarchy = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const productHierarchy = await getProductHierarchy();

            dispatch({
                data: productHierarchy,
                type: actions.UPDATE_TCSM_AUDIT_CLAIM_PRODUCT_HIERARCHY_SUCCESS
            });

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/action-creators/get-product-hierarchy.js